import { getGameplaySessionContext } from "@dawn/adapters";
import type {
  GameplayEventName,
  GameplayEventPropertyMap,
} from "@/analytics/gameEvents";
import { capturePostHogEvent, isPostHogInitialized } from "@/analytics/posthog";

/** Untyped sink for `AnalyticsPort` — session-enriched PostHog capture. */
export function captureGameplayEventRaw(
  event: string,
  properties?: Record<string, unknown>,
): void {
  if (!isPostHogInitialized()) {
    return;
  }

  const context = getGameplaySessionContext();
  if (!context) {
    return;
  }

  capturePostHogEvent(event, {
    session_id: context.sessionId,
    locale: context.locale,
    debug_mode: context.debugMode,
    deploy_target: context.deployTarget,
    ...(properties ?? {}),
  });
}

export function captureGameplayEvent<E extends GameplayEventName>(
  event: E,
  ...args: undefined extends GameplayEventPropertyMap[E]
    ? [properties?: undefined]
    : [properties: GameplayEventPropertyMap[E]]
): void {
  captureGameplayEventRaw(
    event,
    args[0] as Record<string, unknown> | undefined,
  );
}
